import Controller from "./routes.controller";
import template from "./routes.html";

const routes = {
  template,
  controller: Controller,
};

export default routes;



// WEBPACK FOOTER //
// ./src/pages/routes/routes.component.js